import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text/text';
import {extraMediaCount} from '@Components/ai-chat-window/components/entity-card/entity-card.library';
import type {MediaCountBadgeProps} from './media-count-badge.types';
import styles from './media-count-badge.module.scss';

export function MediaCountBadge({mediaCount}: MediaCountBadgeProps): ReactElement | null {
  const moreMediaCount = extraMediaCount(mediaCount);
  if (moreMediaCount === 0) {
    return null;
  }

  return (
    <span className={styles.mediaCountBadge} role="img" aria-label={window.i18next.t('pmwjs_ai_chat_card_more_media', {count: moreMediaCount})}>
      <Text val={`+${moreMediaCount}`} size={TextSize.SM} bold className={styles.mediaCountText} attributes={{'aria-hidden': 'true'}} />
    </span>
  );
}
